import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IdentityPermission } from '../../../shared/models/permission.model'; 

 
@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private baseUrl: string = '';

  constructor(
    private _http: HttpClient, 
  ) {
    this.baseUrl = `${environment.baseUrl}/identity/api/`;
  }

  // ✅ Create Permission
  createPermission(permissionData: Partial<IdentityPermission>): Observable<IdentityPermission> {
    return this._http.post<IdentityPermission>(`${this.baseUrl}create`, permissionData)
      .pipe(catchError(this.handleError));
  }

  // ✅ Get All Permissions
  getAllPermissions(portalId:number = 1): Observable<IdentityPermission[]> {
    return this._http.get<IdentityPermission[]>(`${this.baseUrl}permission/GetByPortal/${portalId}`)
      .pipe(catchError(this.handleError));
  }

  // ✅ Get Permission by ID
  getPermissionById(id: number): Observable<IdentityPermission> {
    return this._http.get<IdentityPermission>(`${this.baseUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }

  // ✅ Get Permission by User
  getPermissionByUser(): Observable<any[]> {
    return this._http.get<any[]>(`${this.baseUrl}role/permission-by-user`)
      .pipe(catchError(this.handleError));
  }

  // ✅ Update Permission
  updatePermission(id: number, permissionData: Partial<IdentityPermission>): Observable<IdentityPermission> {
    return this._http.put<IdentityPermission>(`${this.baseUrl}/update/${id}`, permissionData)
      .pipe(catchError(this.handleError));
  }

  // ✅ Delete Permission
  deletePermission(id: number): Observable<void> {
    return this._http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }

  // ✅ Common Error Handler
  private handleError(error: unknown) {
    console.error('API Error:', error);

    // Extract clean, readable message
    const httpError = error as any;
    const message =
      httpError?.error?.message ||
      httpError?.message ||
      'An unexpected error occurred';

    // Return a simple object, no Angular default wrapping
    return throwError(() => ({ message }));
  }
}
